import { render } from "./BaseVideoElementcopy.vue?vue&type=template&id=2329fc2c&scoped=true&ts=true"
import script from "./BaseVideoElementcopy.vue?vue&type=script&lang=ts"
export * from "./BaseVideoElementcopy.vue?vue&type=script&lang=ts"

import "./BaseVideoElementcopy.vue?vue&type=style&index=0&id=2329fc2c&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2329fc2c"]])

export default __exports__